
/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
// import formJSON from './formElement.json';
import * as React from 'react';
import { useReducer, useState, useEffect } from 'react';

import { FormContext } from './FormContext'
import Element from '../../FormsControls/Element';
import elementValidation from '../validation';
import ThemeControls from '../../Component/AllThemesControl';
import { FormJSONCreateContext } from '../FormJSONCreateContext';
import { AltRoute } from '@mui/icons-material';


function FormRenderer(props) { 
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const { contextJson, apiContextObj } = React.useContext(FormJSONCreateContext);
  const [elements, setElements] = useState(null);
  const [columnSum, setColumnSum] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const forceUpdate = React.useCallback((args) => setElements(args), []);  

  useEffect(() => {
    forceUpdate(props.formJSON)
  },[props.formJSON])

  //console.log(props.formJSON.fields)
  // //console.log(contextJson)

  const createNewRow = (field, uqColValue) => ({
    ...field,
    field_id: field.field_id + uqColValue,
    field_value: field.field_type === "date"
      ? (Array.isArray(field.field_value) && field.field_value.length > 0 ? field.field_value[0] : "")
      : field.field_default_value
        ? field.field_default_value
        : "",
    field_label: "",
    field_runtime_ops: field.field_runtime_ops
      ? field.field_runtime_ops.map(opItem => ({
        ...opItem,
        ops: opItem.ops
      }))
      : []
  });
  
  
  const { fields } = elements ?? {}

  const generateUniqueId = () => {
    return Math.random().toString(36).substring(1);
  };
  var uqColValue = generateUniqueId();

  const newRow = fields && fields.map((field, index) => createNewRow(field, uqColValue));

  useEffect(() => {
    if (newRow) {
      setTableRows([newRow])
    }
  }, [fields, props.row]);

  const handleChange = (id, event, valueStr, maxValue) => {

    const newElements = { ...elements }
    if(props.formType==="TabFormRow"){
      const groupedData = {};
    const updatedRows = [...tableRows];
    updatedRows.forEach((row) => {
      row.forEach((field) => {
        if (field.field_id === id) {
          field.field_value = valueStr;
        }
      });
    });
    setTableRows(updatedRows);

  }
  
    Object.keys(contextJson).forEach((key, index) => {
      if (key !== "xioFEConfig") {
        let _object = contextJson[key];
        contextJson[key].fields.forEach((field, index) => {
          const { field_type, field_id } = field;
          //////console.log(field_id, id, field_id === id);
          if(field_type==='nestedRender'){
            Object.keys(field.field_context).forEach((key, index) => {
              // //////console.log(key)
              if (key !== "xioFEConfig") {
                field.field_context[key].fields.map((field) => {
                  if (field.field_id === id) {
                    field.field_value = valueStr;
                  }
                  return field;
                });
              }
            });
          }else{
            if (id === field_id) {
              switch (field_type) {
                case 'checkbox':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  break;
                case 'qRCode':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  contextJson[key].fields[index]['url'] = event;
  
                  break;
                case 'uploadFileExcel':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  contextJson[key].fields[index]['field_file_format'] = event;
  
                  break;
                case 'customer360Search':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  contextJson[key].fields[index]['field_SearchValue'] = event;
                  break;
                case 'customer360Select':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  contextJson[key].fields[index]['field_SearchValue'] = event;
                  break;
                case 'date':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  contextJson[key].fields[index]['field_value_2'] = event;
                  break;
                case 'multiSelect':
                  let _tempArr = [];
                  if (typeof (valueStr) !== "string") {
                    valueStr.map((item, index) => {
                      if (_tempArr.length > 0 && item) {
                        _tempArr.push(item)
                      } else {
                        if (item) {
                          (_tempArr[0] = item)
                        }
                      }
                    })
                  }
                  contextJson[key].fields[index]['field_value'] = String(_tempArr);
                  break;
                case 'checkBoxList':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  break;
                case 'customInput':
                  contextJson[key].fields[index]['field_value'] = valueStr
                  contextJson[key].fields[index]['field_value_2'] = event
                  break;
                case 'routingInfo':
                  contextJson[key].fields[index]['field_value'] = valueStr
                  contextJson[key].fields[index]['field_value_temp'] = event
                  contextJson[key].fields[index]['field_maxvalue'] = maxValue
                  break;
                case 'custom':
                  contextJson[key].fields[index]['field_value'] = JSON.stringify(JSON.stringify(valueStr))
                  break;
                case 'qRCodeUpload':
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  break;
                case 'nestedAddRowRender':
                    contextJson[key].fields[index]['field_value'] = valueStr;
                  break;
  
                default:
                  contextJson[key].fields[index]['field_value'] = valueStr;
                  break;
              }
            }
          }
          setTimeout(forceUpdate(props.formJSON), 0);
          // setTimeout(forceTableRow(props.formJSON), 0);
        })
      }
      let customJsonContext;
      function StrtoJSON(strObj) {
        if (typeof (strObj) !== "string") {
          return { strObj }
        }
        else {
          if (strObj != "") {
            return StrtoJSON(JSON.parse(strObj));
          } else {

          }
        }
      }
      Object.keys(contextJson).forEach((key, index) => {
        if (key !== "xioFEConfig") {
          let _object = contextJson[key];
          contextJson[key].fields.forEach((field, index) => {
            const { field_type, field_value } = field;
            if (field_type === 'custom' && field_value !== "") {
              let valueStrCustom = StrtoJSON(field_value);
              customJsonContext = valueStrCustom.strObj;
              if (customJsonContext)
                Object.keys(customJsonContext).forEach((_key, _index) => {
                  let __object = customJsonContext[_key]
                  __object.forEach((_field, __index) => {
                    const { field_id } = _field;
                    if (id === field_id) {
                      customJsonContext[_key][__index].field_value = valueStr;
                      contextJson[key].fields[index]['field_value'] = JSON.stringify(JSON.stringify(customJsonContext))
                    }
                  })

                })
            }
            setTimeout(forceUpdate(newElements), 0);

          })
        }
      });

    });
  }
// //console.log(tableRows)
  useEffect(() => {
    let resultEval;
    if(props.formType==="TabFormRow"&&tableRows.length>0){
      // //console.log('tableRows')
      tableRows?.forEach(fields => {
              // //////console.log(thisField);
              fields.map((thisField)=>{
                if (thisField.field_runtime_ops) {
                  thisField.field_runtime_ops.forEach(field => {
                    if (field.condition)
                      //var resultEval;
    
                    var stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
                    // alert(stmt);
                    eval(stmt);
                    // //console.log(stmt);
                    // //console.log(field.ops);
                    // //console.log(resultEval);
                    if (resultEval) {
                      //////console.log(eval(field.ops));
                      eval(field.ops);
                      // setTimeout(forceUpdate(tableRows), 0);
                      setTimeout(forceUpdate(props.formJSON), 0);
                    }
                  });
                }
              })
            })
    }else{
      Object.keys(contextJson).forEach((key, index) => {
        if (key !== "xioFEConfig") {
          let _object = contextJson[key];
          if (contextJson[key].fields)
            contextJson[key].fields.forEach(thisField => {
              // //console.log(thisField);
              if(thisField.field_type==='nestedRender'&&props.formType!=="TabFormRow"){
                Object.keys(thisField.field_context).forEach((key, index) => {
                  // //////console.log(key)
                  if (key !== "xioFEConfig" && thisField.field_context['xioFEConfig'].TabStyle!=='TabFormRow') {
                    thisField.field_context[key].fields.forEach((thisField) => {
                      if (thisField.field_runtime_ops) {
                        thisField.field_runtime_ops.forEach(field => {
                          if (field.condition)
                            //var resultEval;
          
                          var stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
          
                          eval(stmt);
                         
                          if (resultEval) {
                            //////console.log(eval(field.ops));
                            eval(field.ops);
                            setTimeout(forceUpdate(props.formJSON), 0);
                          }
                        });
                      }
                    });
                  }
                });
              }else if(thisField.field_type==='nestedRender'&&props.formType==="TabFormRow"){
                // //console.log('nestedRender')

              }else{
                if (thisField.field_runtime_ops) {
                  thisField.field_runtime_ops.forEach(field => {
                    if (field.condition)
                      //var resultEval;
                      if (field.condition.hasOwnProperty("AND")) {
                        const conditions = field.condition.AND.map((item) => {
                          if(item.checkVal == null ){
                            return "thisField." + item.field + " " + item.operator + " " + item.checkVal + "";
                          }else{
                            return "thisField." + item.field + " " + item.operator + " \"" + item.checkVal + "\"";
                          }
                          });
                          
                        const combinedCondition = conditions.join(" && ");
                    
                        var stmt = "resultEval = " + combinedCondition;
              
                        eval(stmt);
                    }else  if (field.condition.hasOwnProperty("OR")) {
                      const conditions = field.condition.OR.map((item) => {
                        if(item.checkVal == null ){
                          return "thisField." + item.field + " " + item.operator + " " + item.checkVal + "";
                        }else{
                          return "thisField." + item.field + " " + item.operator + " \"" + item.checkVal + "\"";
                        }
                      });
                      
                      const combinedCondition = conditions.join(" || ");
                  
                      var stmt = "resultEval = " + combinedCondition;

                      // //console.log(resultEval) 
                      // //console.log(stmt) 
                      eval(stmt);
                  } else {
                      var stmt = ""
                        if(field.condition.checkVal===true){
                          stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + "" + field.condition.checkVal + ""
                        }else{
                          stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
                        }
                      eval(stmt);
                    } 
                    // //console.log(stmt);
                    // //console.log(resultEval);
                    if (resultEval) {
                      // //console.log(eval(field.ops));
                      eval(field.ops);
                      // setElements(props.formJSON)
                      setTimeout(forceUpdate(props.formJSON), 0);
                    }
                  });
                }
              }
         
            })
        }
      })
    }
  })

  const fieldColumns = [];
  if(props.formJSON){
    const tableFields = props.formJSON.fields;

    const fieldColumn = tableFields.map((field) => ({
      key: field.field_id,
      title: field.field_label,
      dataIndex: field.field_id,
      columnSum: field.field_Sum,
      field_type: field.field_type,
    }));
    fieldColumns.push(...fieldColumn);
  }


  const addRow = () => {
    uqColValue = generateUniqueId();
    setTableRows((prevRows) => [...prevRows, newRow]);
  };

  const removeRow = (index) => {
    setTableRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

// console.log(tableRows)

  useEffect(() => {
    if(props.formType==="TabFormRow"){
    if (tableRows.length > 0 && tableRows !== undefined) {
      const groupedData = {};
      tableRows.forEach((row, rowIndex) => {
        row.forEach((field) => {
          const fieldIdParts = field.field_id.split(".")[0];
          if (!groupedData[fieldIdParts]) {
            groupedData[fieldIdParts] = [];
          }
          groupedData[fieldIdParts].push(field.field_value);
          Object.keys(contextJson).forEach((key, index) => {
            if (key !== "xioFEConfig") {
              contextJson[key].fields.map((field) => {
                if (field.field_id === fieldIdParts&&field.field_type!=="nestedRender"){
                  field.field_value = groupedData[fieldIdParts];
                }else if(field.field_type==="nestedRender"&&field.field_context){
                  field.field_value=tableRows;
                  Object.keys(field.field_context).forEach((key, index) => {
                    // //////console.log(key)
                    if (key !== "xioFEConfig") {
                      field.field_context[key].fields.map((field) => {
                        if (field.field_id === fieldIdParts) {
                          field.field_value = groupedData[fieldIdParts];
                        }
                        return field;
                      });
                    }
                  });
                }
                return field;
              });
            }
          });
        });
      });
    }}
  },[tableRows])

const calculateColumnSum = (fieldId) => {
  let sum = 0;
  if (props.formJSON && props.formJSON.fields) {
    const tableFields = props.formJSON.fields;

    const relevantFields = tableFields.filter(
      (field) =>
        field.field_id === fieldId &&
        field.field_Sum === 'yes' &&
        !isNaN(parseFloat(field.field_value))
    );

    relevantFields.forEach((field) => {
      const values = field.field_value;

      if (Array.isArray(values)) {
        values.forEach((value) => {
          sum += parseFloat(value) || 0;
        });
      } else {
        sum += parseFloat(values) || 0;
      }
    });
  }
  return sum;
};

useEffect(() => {
  fieldColumns.forEach((column) => {
    if (column.columnSum === 'yes') {
      const sum = calculateColumnSum(column.dataIndex);
      // Update state with the calculated sum
      setColumnSum((prevColumnSum) => ({
        ...prevColumnSum,
        [column.dataIndex]: sum,
      }));
    }
  });
}, [tableRows]);

  return (
    <React.StrictMode>
      <FormContext.Provider value={{ handleChange }}>
        {(props.formType==="TabFormRow")?
          <div className={classes.subtable}>
            <div className={classes.btnHeader}>
              <h1>{props.formJSON.page_heading_label?props.formJSON.page_heading_label:''}</h1>
              <button className={classes.subBtn} onClick={addRow}>
                Add Row
              </button>
            </div>
           <div style={{overflow:'auto'}}>
           <table>
              <thead>
                <tr>
                  {fieldColumns.map((column) => (
                    column.field_type&&<th key={column.key}>{String(column.title)}</th>
                  ))}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableRows && tableRows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row && row.map((field, fieldIndex) => (
                      field.field_type&&<td key={field.field_id}>
                        <Element key={rowIndex} field={field} />
                      </td>
                    ))}
                    <td>
                      <button
                        onClick={() => removeRow(rowIndex)}
                        disabled={tableRows.length === 1}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
                  {props.formJSON.field_Sum_Row&&props.formJSON.field_Sum_Row==="true"&&<tr className="noBorder">
                  {fieldColumns.map((column) => (
                    <td key={column.key}>
                      {column.columnSum==='yes'&&columnSum[column.dataIndex]}
                      </td>
                  ))}
                  <td>Sum</td>
                </tr>}
              </tbody>
            </table>
           </div>
           {/* <div>
           <table>
              <thead>
                <tr className="noBorder">
                  {fieldColumns.map((column) => (
                    <th key={column.key}>{column.columnSum==='yes'&&String(column.title)}</th>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                  <tr className="noBorder">
                  {fieldColumns.map((column) => (
                    <td key={column.key}>
                      {column.columnSum==='yes'&&columnSum[column.dataIndex]}
                      </td>
                  ))}
                  <td>Sum</td>
                </tr>
              </tbody>
            </table>
           </div> */}
          </div>
        :
          <div className="App containers">
            {fields ? fields.map((field, i) => {
              return (<Element key={i} field={field} />)
            }) :
              null}
          </div>
        }

      </FormContext.Provider>

    </React.StrictMode>
  );
}

export default FormRenderer;
